/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function UserCircle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Circle cx={128} cy={120} r={44} />
        <Path d="M128,24A104,104,0,1,0,232,128,104.11791,104.11791,0,0,0,128,24Zm65.75806,162.41016a79.70266,79.70266,0,0,0-24.43091-22.97461,59.83641,59.83641,0,0,1-82.6543,0A79.7048,79.7048,0,0,0,62.2417,186.41016a88.00015,88.00015,0,1,1,131.51636,0Z" />
      </G>
    </Svg>
  );
}

export default UserCircle;
